import React from 'react';
import { motion } from 'framer-motion';
import { Users, PlusCircle, PieChart, ArrowRightLeft, CheckCircle2 } from 'lucide-react';
const steps = [{
  icon: <Users className="w-6 h-6 text-kitty-dark" data-id="element-115" />,
  title: 'Create a kitty',
  description: 'Start a shared space for a trip, dinner, house share, event, night out or group plan.'
}, {
  icon: <PlusCircle className="w-6 h-6 text-kitty-dark" data-id="element-116" />,
  title: 'Add expenses',
  description: 'Add what was paid for, who paid, and who the expense should be shared with.'
}, {
  icon: <PieChart className="w-6 h-6 text-kitty-dark" data-id="element-117" />,
  title: 'Split fairly',
  description: 'Split equally or enter custom amounts when people owe different shares.'
}, {
  icon: <ArrowRightLeft className="w-6 h-6 text-kitty-dark" data-id="element-118" />,
  title: 'See the simplest way to settle',
  description: 'KittyPot works out the fewest payments needed to make everyone even.'
}, {
  icon: <CheckCircle2 className="w-6 h-6 text-kitty-dark" data-id="element-119" />,
  title: 'Mark it as paid',
  description: 'Settle outside KittyPot by bank transfer, cash or another method, then mark it as paid and confirm when received.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-28 lg:py-36 bg-white" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-122">
          <div className="inline-flex bg-kitty-yellow-100 text-kitty-yellow-800 rounded-full px-3 py-1 text-xs font-semibold mb-4" data-id="element-123">
            How it works
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-124">
            Simple as 1, 2, 3, done.
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto mb-3" data-id="element-125">
            Create a kitty, add expenses, choose who they're shared with, and
            KittyPot works out who pays who.
          </p>
          <p className="text-sm font-semibold text-kitty-dark/50 mb-5" data-id="element-126">
            No chasing. No spreadsheets. No stress.
          </p>
        </div>

        <div className="relative" data-id="element-127">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0 border-t-2 border-dashed border-kitty-yellow-200 -z-10" data-id="element-128"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-4" data-id="element-129">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-130">
                <div className="w-24 h-24 rounded-3xl bg-kitty-yellow-50 flex items-center justify-center mb-6 group-hover:bg-kitty-yellow-100 transition-colors relative shadow-sm border border-kitty-yellow-100" data-id="element-131">
                  {/* Number badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center border-4 border-white shadow-sm" data-id="element-132">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-lg font-bold text-kitty-dark mb-2" data-id="element-133">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed px-2" data-id="element-134">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}